import { render, staticRenderFns } from "./InventoryLoss.vue?vue&type=template&id=0599a1e3&scoped=true"
import script from "./InventoryLoss.vue?vue&type=script&lang=js"
export * from "./InventoryLoss.vue?vue&type=script&lang=js"
import style0 from "./InventoryLoss.vue?vue&type=style&index=0&id=0599a1e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0599a1e3",
  null
  
)

export default component.exports